import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import MarkdownWithRouter from "src/components/MarkdownWithRouter";
import EventFinished from "src/components/EventFinished";

const SurfAndTurf2025 = () => {
  const { t, i18n } = useTranslation();

  return (
    <SurfAndTurf2025Div>
      <EventFinished eventKey="surfAndTurf2025" eventType="promotion" />
      <Hero
        bgImage="promotions/dining/surf-and-turf-2025/S&T-lobster-Header-2560x800px.jpg"
        buttonSettings={null}
        image={`promotions/dining/surf-and-turf-2025/S&T-lobster-Logo-2400px-${i18n.language}.png`}
        darkenBg={0}
        description={t("diningPromos.surfAndTurf2025.hero.title")}
        descriptionBgColor="#0000004d"
      >
        {/* <p>For just $19</p> */}
      </Hero>
      <MainContentDiv>
        <container-div>
          <Row className="g-4 mb-5" xs={1} md={2}>
            <Col>
              <SubTitleSection
                as={"h2"}
                subTitle={t("diningPromos.surfAndTurf2025.content.subtitle")}
              />
              <ReactMarkdown className="desc">
                {t("diningPromos.surfAndTurf2025.content.lunch.description")}
              </ReactMarkdown>
              <MarkdownWithRouter>
                {t("diningPromos.surfAndTurf2025.content.pgPlayersCard")}
              </MarkdownWithRouter>
            </Col>
            <Col className="pt-md-4">
              <ResponsiveImage
                src={`promotions/dining/surf-and-turf-2025/S&T-lobster-Secondary-LP-Image-2400x1600-${i18n.language}.jpg`}
                alt={t("diningPromos.surfAndTurf2025.hero.title")}
              />
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
      <container-div>
        <center-content>
          <p className="small">
            {t("diningPromos.surfAndTurf2025.content.smallText")}
          </p>
        </center-content>
      </container-div>
    </SurfAndTurf2025Div>
  );
};

const SurfAndTurf2025Div = styled.div`
  width: 100%;
  height: auto;
  /* min-height: 100vh; */
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .small {
    text-align: center;
    max-width: 1100px;
    word-wrap: break-word;
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  h2:after {
    border-color: #e70a02;
  }
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background: rgba(0, 0, 0, 0.5);
  }
  /* @media (min-width: 992px) {
    padding: 3rem 0;
  } */
  height: auto;
  width: 100%;
  text-align: left;
  .p_1 strong {
    white-space: nowrap;
  }
  .desc strong {
    color: #FF9000;
  }
  p {
    margin-bottom: 1rem;
  }
`;

export default SurfAndTurf2025;
